export default __webpack_public_path__ + "static/P_SearchThumb_VLC-027a2f4004603b2a2f85f8a3cc795089.webp";